@let obs =
  {
    isLoading: isLoading$ | async,
    isTabletMdUp: isTabletMdUp$ | async,
    banners: banners$ | async,
    filteredBanners: filteredBanners$ | async,
  };

@if (obs.banners && obs.banners.label && obs.banners.bannerWithTabGroups.length) {
  <h2 class="text-b2-s text-md-b2-m text-lg-h4-s banner-with-tab-title container-v2">
    {{ obs.banners.label }}
  </h2>

  <sd-banner-with-tab-group
    [bannersGroup]="obs.banners.bannerWithTabGroups"
    [selectedGroup]="selectedGroup()"
    (selectGroup)="onSelectGroup($event)"
  ></sd-banner-with-tab-group>

  <div class="container-v2 banner-with-tabs">
    @if (obs.filteredBanners && obs.filteredBanners.length) {
      @if (obs.isTabletMdUp) {
        <sd-swiper [items]="obs.filteredBanners" [config]="config">
          <ng-template let-item="item">
            <div
              class="item-wrapper"
              [sdInViewport]="0.5"
              [intersectedOnce]="true"
              (intersected)="onBannerIntersect(item)"
            >
              <sd-banner-with-tab-item [banner]="item"></sd-banner-with-tab-item>
            </div>
          </ng-template>
        </sd-swiper>
      } @else {
        @for (banner of obs.filteredBanners | slice: 0 : 4; track banner.url) {
          <sd-banner-with-tab-item
            [banner]="banner"
            [sdInViewport]="0.5"
            [intersectedOnce]="true"
            (intersected)="onBannerIntersect(banner)"
          ></sd-banner-with-tab-item>
        }

        <div class="banner-with-tab-default">
          <a [routerLink]="obs.banners.link">
            <h4 class="banner-with-tab-default-title text-b4-l-500">Смотреть все</h4>
            <button sdNavButton class="button-nav-link" [icon]="iconTypes.ARROW_NEXT" size="'s'"></button>
          </a>
        </div>
      }
    }
  </div>
} @else if (obs.isLoading) {
  <div class="container-v2 banner-with-tab-skeleton sd-group-skeleton-gradient-wave">
    <div class="banner-with-tab-title sd-skeleton"></div>
    @let numberOfGroupSkeletons = 6;
    <div class="banner-with-tab-group-container">
      <div class="banner-with-tab-group-skeleton">
        @for (i of [].constructor(numberOfGroupSkeletons); track $index) {
          <div class="sd-skeleton"></div>
        }
      </div>
      <div class="banner-with-tab-group-paging sd-skeleton"></div>
    </div>
    <div class="banner-with-tabs">
      @let numberOfSkeletons = 4;
      @for (i of [].constructor(numberOfSkeletons); track $index) {
        <div class="banner-with-tab-item sd-skeleton"></div>
      }
      @if (!obs.isTabletMdUp) {
        <div class="banner-with-tab-default sd-skeleton"></div>
      }
    </div>
  </div>
}
